import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./components/activeDirectoryIntegrationButton/oauthConfig";

const msalInstance = new PublicClientApplication(msalConfig);

async function init() {
  await msalInstance.initialize();
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App msalInstance={msalInstance} />
    </React.StrictMode>
  );
  reportWebVitals();
}

init();
